import React from 'react';
import Link from '@/lighting-app/compat/NextLink';
import { Zap, ArrowLeft } from 'lucide-react';

export default function HeroSection() {
  return (
    <section className="hero-bg min-h-screen flex items-center relative overflow-hidden pt-20">
      {/* Background decorative circles */}
      <div className="absolute top-20 left-10 w-64 h-64 rounded-full opacity-5"
        style={{ background: 'radial-gradient(circle, #F7941D, transparent)' }} />
      <div className="absolute bottom-20 right-10 w-96 h-96 rounded-full opacity-5"
        style={{ background: 'radial-gradient(circle, #F7941D, transparent)' }} />

      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="slide-up">
            <div className="inline-flex items-center gap-2 bg-white/10 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <Zap size={16} className="text-primary" />
              <span>حاسبة إضاءة هندسية دقيقة</span>
            </div>

            <h1 className="text-hero text-white mb-6">
              اختر الإضاءة{' '}
              <span className="text-primary">المناسبة</span>{' '}
              لمكانك بسهولة
            </h1>

            <p className="text-gray-300 text-lg leading-relaxed mb-8 max-w-lg">
              أداة ذكية تساعدك على تصميم إضاءة جديدة أو تقييم الإضاءة الحالية لمكانك بدقة وسهولة. مبنية على معايير الإضاءة الهندسية الاحترافية.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                href="/design-new-lighting-wizard"
                className="btn-primary px-8 py-4 text-base font-bold rounded-xl flex items-center justify-center gap-3 group"
              >
                <span>ابدأ التصميم</span>
                <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
              </Link>
              <Link
                href="/inspect-existing-lighting-wizard"
                className="px-8 py-4 rounded-xl border-2 border-white/30 text-white font-bold text-base hover:border-primary hover:bg-white/10 transition-all duration-200 flex items-center justify-center gap-2"
              >
                افحص الإضاءة الحالية
              </Link>
            </div>

          </div>

          {/* Visual */}
          <div className="hidden lg:flex items-center justify-center">
            <div className="relative">
              {/* Room mockup */}
              <div className="w-80 h-80 bg-white/5 rounded-2xl border border-white/10 relative overflow-hidden">
                {/* Room grid */}
                <div className="absolute inset-4 grid grid-cols-3 grid-rows-3 gap-4">
                  {Array.from({ length: 9 })?.map((_, i) => (
                    <div
                      key={`hero-light-${i + 1}`}
                      className="flex items-center justify-center"
                      style={{ transitionDelay: `${i * 80}ms` }}
                    >
                      <div className="w-8 h-8 rounded-full bg-primary/20 border-2 border-primary/50 flex items-center justify-center">
                        <div className="w-3 h-3 rounded-full bg-primary animate-pulse" />
                      </div>
                    </div>
                  ))}
                </div>
                {/* Dimension labels */}
                <div className="absolute bottom-2 left-0 right-0 text-center text-xs text-gray-500">5.0 م</div>
                <div className="absolute top-0 bottom-0 right-2 flex items-center">
                  <span className="text-xs text-gray-500 -rotate-90">4.0 م</span>
                </div>
              </div>

              {/* Floating cards */}
              <div className="absolute -top-4 -right-8 bg-card rounded-xl px-4 py-3 shadow-card">
                <div className="text-xs text-muted-foreground">الإضاءة</div>
                <div className="text-lg font-bold text-primary font-tabular">528 Lux</div>
              </div>
              <div className="absolute -bottom-4 -left-8 bg-card rounded-xl px-4 py-3 shadow-card">
                <div className="text-xs text-muted-foreground">المصابيح</div>
                <div className="text-lg font-bold text-foreground font-tabular">9 مصباح</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}